import { render, staticRenderFns } from "./LogoDisplay.vue?vue&type=template&id=3ccb6729&scoped=true&"
import script from "./LogoDisplay.vue?vue&type=script&lang=js&"
export * from "./LogoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LogoDisplay.vue?vue&type=style&index=0&id=3ccb6729&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb6729",
  null
  
)

export default component.exports